import React, { useState } from "react";
import BillsReport from "./BillsReports";
import PatientVisitsReport from "./PatientVisitsReport";
import DrugsSoldReport from "./DrugsSoldReport";

const ReportsManagement = () => {
  const [activeTab, setActiveTab] = useState("bills");

  const tabs = [
    { key: "bills", label: "Bills Summary", component: <BillsReport /> },
    { key: "visits", label: "Patient Visits", component: <PatientVisitsReport /> },
    { key: "drugs", label: "Dispensation Report", component: <DrugsSoldReport /> },
  ];

  return (
    <div className="space-y-4">
      {/* Tab Buttons */}
      <div className="flex mt-[10px] gap-[5px] justify-end">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-4 py-2 rounded ${
              activeTab === tab.key ? "primary extra-wide" : "secondary"
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {tabs.find((tab) => tab.key === activeTab)?.component}
      </div>
    </div>
  );
};

export default ReportsManagement;
